import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdjuntosService {

  private readonly baseUrl = `${environment.apiUrl}/api/pqrsd/adjuntos`;

  constructor(private readonly http: HttpClient) { }

  public downloadFormFile(solicitudId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/descargar/${solicitudId}`, { responseType: 'blob' });
  }

}
